// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import MessageOutlined from '/data/luanniao-ui-release/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/MessageOutlined';
import LineChartOutlined from '/data/luanniao-ui-release/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/LineChartOutlined';
import MailOutlined from '/data/luanniao-ui-release/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/MailOutlined';
import SettingOutlined from '/data/luanniao-ui-release/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { MessageOutlined, LineChartOutlined, MailOutlined, SettingOutlined };
